import React from "react";
import {Container, Spinner} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import {IImageModel} from "../../types/manualFinder";
import {useExtractedImagesState, useFeedbackHandler, useImageActions, useImageFetching} from "../../hooks";
import ImageCard from "./ImageCard";
import {ManualDrawer} from "../ManualDrawer/ManualDrawer";
import "./ManualFinderManualSelection.scss";

interface IImagesManualSelectionProps {
    extractedImages: Record<string, IImageModel>[]
}

export const ManualFinderManualSelection: React.FC<IImagesManualSelectionProps> = ({extractedImages}) => {
    const {t} = useTranslation();
    const {parentImages, setParentImages, isLoadingImages} = useImageFetching(extractedImages);
    const {onRefresh, createDropFileObject, reloadTaImages} = useImageActions(parentImages, setParentImages);
    const {handleFeedback} = useFeedbackHandler(parentImages, setParentImages);
    const {displayImageManuals} = useExtractedImagesState();

    if (isLoadingImages) {
        return (
            <Container className="w-80 d-flex justify-content-center align-items-start" style={{paddingTop: "20vh"}}>
                <Spinner animation="border" role="status" className="me-3">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
                <span>{t("ExtractedImages.ImagesExtractionLoading")}</span>
            </Container>
        );
    }

    return (
        <div className={`extracted-images-container d-flex flex-row ${displayImageManuals ? 'shift-left' : ''}`}>
            {displayImageManuals ? (<ManualDrawer forceFeedback={true} />) : <></>}
            <div className="extracted-images">
                {parentImages.length > 0 ? (
                    parentImages.map((imageSet, index) => (
                        <ImageCard imageSet={imageSet} index={index}
                                   createDropFileObject={createDropFileObject}
                                   onClickFeedback={handleFeedback}
                                   onClickRefresh={onRefresh}
                                   reloadTaImages={reloadTaImages}
                                   key={index}/>
                    ))
                ) : (
                    <Container className="d-flex justify-content-center align-items-start" style={{paddingTop: "20vh"}}>
                        {t("ExtractedImages.NoImagesFoundMessage")}
                    </Container>
                )}
            </div>
        </div>
    );
};
